/* eslint-disable no-param-reassign */
import React, { Component, Fragment, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { CaretRightFilled, EditOutlined } from '@ant-design/icons';

import { Table } from 'antd';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import PRZButton from '../../../../../Common/UI/PRZButton';
import './style.scss';

/**
 *
 */
class OtherCharge extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    const { priceMasking, finishedGoods, extraCharges } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    this.state = {
      productListColumns: [
        {
          title: 'Charge Name',
          render: (text, record) => {
            const {
              createMOLoading, updateMOLoading, formSubmitted, handleChargeChange, multipleFG, MONEY,
            } = this.props;
            const {
              hoveredRowReason, editingReasonIndex,
            } = this.state;
            return (
              <div>
                <div
                  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                  onMouseEnter={() => this.setState({ hoveredRowReason: record?.key })}
                  onMouseLeave={() => this.setState({ hoveredRowReason: null })}
                >
                  <div>
                    {editingReasonIndex === record?.key ? (
                      <H3FormInput
                        name="a valid charge name"
                        type="text"
                        containerClassName="orgInputContainer mo-form__input-row__input"
                        labelClassName="orgFormLabel"
                        inputClassName="orgFormInput input"
                        placeholder=""
                        onChange={(e) => {
                          handleChargeChange(record?.fg_tenant_product_id, e.target.value || 'empty', '', record?.key);
                        }}
                        value={record.charge_name}
                        showError={(!record?.charge_name?.toString())}
                        disabled={createMOLoading || updateMOLoading}
                        loading={createMOLoading || updateMOLoading}
                        onBlur={() => {
                          if (record.charge_name) {
                            this.setState({ editingReasonIndex: null });
                          }
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          marginTop: '6px',
                          marginBottom: '3px',
                          fontWeight: 500,
                          fontSize: '12px',
                        }}
                      >
                        <div className="oc-table-estimated-amount__wrapper">
                          {record.charge_name}
                        </div>
                        {hoveredRowReason === record?.key && (
                          <EditOutlined
                            style={{ marginLeft: '5px', fontSize: '16px', color: 'rgb(65, 150, 255)' }}
                            onClick={() => this.setState({ editingReasonIndex: record?.key })}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          title: 'Estimated Amount',
          width: '180px',
          render: (text, record) => {
            const {
              createMOLoading, updateMOLoading, formSubmitted, handleChargeChange, multipleFG, MONEY,
            } = this.props;
            return (
              <div className="">
                <H3FormInput
                  name="a valid quantity"
                  type="number"
                  containerClassName="orgInputContainer mo-form__input-row__input"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput input"
                  placeholder=""
                  onChange={(e) => {
                    handleChargeChange(record?.fg_tenant_product_id, '', e.target.value || 'empty', record?.key);
                  }}
                  value={record.charge_amount}
                  showError={formSubmitted && (!record?.charge_amount?.toString() || Number(record?.charge_amount) < 0)}
                  disabled={createMOLoading || updateMOLoading}
                  loading={createMOLoading || updateMOLoading}
                  hideInput={isDataMaskingPolicyEnable && isHideCostPrice}
                  popOverMessage={`You don't have access to view/edit ${record.charge_name}`}
                />
              </div>
            );
          },
        },
        // {
        //   title: ' ',
        //   width: '40px',
        //   render: (text, record) => {
        //     const { handleDelete } = this.props;
        //     return (
        //       <Fragment>
        //         <Popconfirm
        //           title="Confirm remove Other Charge?"
        //           onConfirm={() => handleDelete(record.key)}
        //           onCancel={() => {}}
        //           okText="Yes"
        //           cancelText="No"
        //         >
        //           <div className="create-mo-oc__delete-line-button">
        //             <CloseOutlined />
        //           </div>
        //         </Popconfirm>
        //       </Fragment>
        //     );
        //   },
        // },
      ],
    };
  }

  /**
   *
   */
  componentDidMount() {
  }

  /**
   *
   * @param {*} data
   * @return
   */
  getDataSource(data) {
    if (data) {
      return JSON.parse(JSON.stringify(data));
    }
    return [];
  }

  getData = (lines) => [...lines?.filter((item) => item?.tenant_product_info?.product_sku_id),
    ...lines.filter((item) => !item?.tenant_product_info?.product_sku_id),
  ]

  getDataSourceForEachFG = (fgTenantProductId) => this.getData(this.props.extraCharges[fgTenantProductId] ?? []);

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      data, loading, finishedGoods, extraCharges,
    } = this.props;
    const {
      productListColumns,
    } = this.state;
    return (

      <Fragment>
        {finishedGoods?.map((fg) => (
        fg?.tenant_product_info?.tenant_product_id ? (
          <div className="mo-new-rm__wrapper" key={fg.key || uuidv4()}>
            <div className="table__fg">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{
                  display: 'inline-block', fontSize: '13px', fontWeight: 500, marginLeft: '10px',
                }}
                >
                  {fg?.tenant_product_info?.alias_name}
                  {' '}
                  <CaretRightFilled />
                </span>
              </div>
            </div>
            {this.getDataSourceForEachFG(fg?.tenant_product_info?.tenant_product_id)?.length > 0 && (
              <div className="mo-rm-table__wrapper">
                <Table
                  bordered
                  loading={loading}
                  showHeader
                  size="small"
                  scroll={{ x: 'max-content' }}
                  columns={productListColumns}
                  dataSource={this.getDataSourceForEachFG(fg?.tenant_product_info?.tenant_product_id)?.filter((item) => !item?.isChildBom)?.map((line, index) => ({ ...line, sqn: index + 1 }))}
                  pagination={false}
                  rowClassName={(record) => (record?.product_sku_id && !record.tenant_product_info?.tenant_product_id ? 'disabled-mo-rw-table-row' : '')}
                />
              </div>
            )}
          </div>
        ) : null
        ))}
      </Fragment>

    );
  }
}

/**
 *
 * @param UserReducers
 * @param PurchaseOrderReducers
 * @return {{updateCustomPurchaseOrderLoading: *, selectedPurchaseOrder, user}}
 */
const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers, OfferReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  updateCustomPurchaseOrderLoading: PurchaseOrderReducers.updateCustomPurchaseOrderLoading,
  selectedPurchaseOrder: PurchaseOrderReducers.selectedPurchaseOrder,
  getOfferByTenantSkuLoading: OfferReducers.getOfferByTenantSkuLoading,
  priceMasking: UserReducers.priceMasking,
});

/**
 *
 * @return {{}}
 */
const mapDispatchToProps = () => ({

});

OtherCharge.propTypes = {
  loading: PropTypes.bool,
  updateData: PropTypes.func,
  data: PropTypes.any,
  isFlexible: PropTypes.bool,
  handleDelete: PropTypes.any,
  createMOLoading: PropTypes.bool,
  updateMOLoading: PropTypes.bool,
  formSubmitted: PropTypes.bool,
  multipleFG: PropTypes.bool,
  handleChargeChange: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OtherCharge));
